import React, { useEffect, useState } from 'react'
import { Accordion, Button, Card, Col, Form, Row } from 'react-bootstrap'
import { AccordionEventKey, AccordionSelectCallback } from 'react-bootstrap/esm/AccordionContext'
import { GetAppointmentByIdOutput } from '../../../../Adaptor/TUBSIS/controllers/Appointments/models/getAppointmentModels'
import { getAppointmentCOQuestionsByAppointmentId, saveAppointmentCOQuestions } from '../../../../Adaptor/TUBSIS/controllers/AppointmentCOQuestions/AppointmentCOQuestions'
import { AppointmentCOQuestionGroupDto } from '../../../../Adaptor/TUBSIS/controllers/AppointmentCOQuestions/models/saveAppointmentCOQuestionModels'
import { getAppointmentQuestionExcelResult } from '../../../../Adaptor/TUBSIS/controllers/AppointmentQuestions/AppointmentQuestions'

type Props = { appointment: GetAppointmentByIdOutput }

const PatientAppointmentCOQuestions: React.FC<Props> = ({ appointment }) => {

    const [activeQuestionAccordion, setActiveQuestionAccordion] = useState<AccordionEventKey | null>(null)

    const toggleQuestionAccordion: AccordionSelectCallback = (eventKey: AccordionEventKey) => {
        setActiveQuestionAccordion(eventKey === activeQuestionAccordion ? null : eventKey)
    }

    const [appointmentId, setAppointmentId] = useState<number | null>(null)
    const [questionGroupPuan, setQuestionGroupPuan] = useState<number | null>(null)
    const [questionGroupPuanValid, setQuestionGroupPuanValid] = useState<boolean>(false)
    
    const [question1, setQuestion1] = useState<string | null>(null)
    const [question1Point, setQuestion1Point] = useState<number | null>(null)
    const [isValidQuestion1, setIsValidQuestion1] = useState<boolean>(false)

    const [isSelectedQ1C5, setIsSelectedQ1C5] = useState<boolean>(false)//şartlı soru: Q1'de C5 işaretlenirse => Q2 zorunlu değil
    const [isSelectedQ1C1, setIsSelectedQ1C1] = useState<boolean>(false)//şartlı soru: Q1'de C1 işaretlenirse => Q2 ve Q3 zorunlu değil
    
    const getChoiceValue = (choiceId: number): number => {
        switch (choiceId) {
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 34:
                return 5;

            default:
                return 0;
        }
    };

    const [appointmentCOQuestions, setAppointmentCOQuestions] = useState<AppointmentCOQuestionGroupDto | null>(null)
    
    useEffect(() => {
        if (appointment && appointment.appointmentId > 0) {
            getAppointmentCOQuestionsByAppointmentId(appointment.appointmentId)
                .then((response) => {

                    if (response && response.data !== null) {
                        //console.log("girdi buraya", JSON.stringify(response.data), appointment.appointmentId)
                        setAppointmentCOQuestions(response.data)

                        if (response.data.appointmentQuestions && response.data.appointmentQuestions !== null) {
                            response.data.appointmentQuestions.forEach(aq => {
                                if (aq.questionId && aq.questionId === 1) {
                                    setQuestion1(aq.choiceId.toString())
                                    setIsValidQuestion1(true);
                                    setQuestion1Point(aq.point)
                                    setQuestionGroupPuan(aq.point)
                                }
                            });
                        }

                        if (response.data.appointmentCOQuestions && response.data.appointmentCOQuestions !== null) {
                            response.data.appointmentCOQuestions.forEach(aq => {
                                if (aq.questionId && aq.questionId === 2) {
                                    setSelectedDay(aq.selectedDay)
                                    setSelectedMonth(aq.selectedMonth)
                                    setSelectedYear(aq.selectedYear)
                                    setSelectedDate(true)
                                } else if (aq.questionId && aq.questionId === 3) {
                                    setSelectedDay2(aq.selectedDay)
                                    setSelectedMonth2(aq.selectedMonth)
                                    setSelectedYear2(aq.selectedYear)
                                    setIsChecked(aq.isUndecided)
                                    setSelectedDate2(true)
                                }
                            });
                        }

                        setAppointmentId(appointment.appointmentId)
                        
                    }

                    if (response.data?.appointmentCOQuestions.length && response.data?.appointmentCOQuestions.length > 0) {
                        setQuestionGroupPuanValid(true)
                    } else {
                        setQuestionGroupPuanValid(false)
                    } 
                    
                })
                .catch((error) => {
                    console.error("Error fetching user:", error);
                });
        }
    }, [appointment])

    const handleUpdate = async () => {
        // Form verilerini güncellemek için gerekli işlemleri burada gerçekleştirin
        // console.log("Form verileri güncellendi:", userData);

        if (!appointmentId) {
            alert("Randevu bilgisine ulaşılamadığı için HAPA Aşaması kaydedilemedi.")
            return;
        }

        if (!question1 || !isValidQuestion1 || !selectedDate || !selectedDate2) {
            return;
        }

        const requestModel = {
            appointmentCOQuestionGroup: {
                appointmentId: appointmentId,
                appointmentQuestions: [{
                    questionId: 1,
                    choiceId: parseInt(question1),
                    point: question1Point ?? 0
                }],
                appointmentCOQuestions: [{
                    questionId: 2,
                    selectedYear: selectedYear,
                    selectedMonth: selectedMonth,
                    selectedDay: selectedDay,
                    isUndecided: false
                },{
                    questionId: 3,
                    selectedYear: selectedYear2,
                    selectedMonth: selectedMonth2,
                    selectedDay: selectedDay2,
                    isUndecided: isChecked
                }],
            }
        }

        //console.log("rqq",JSON.stringify(requestModel))

        var response = await saveAppointmentCOQuestions(requestModel)

        if (response.success) {
            alert("HAPA Aşaması kaydedildi.")
        } else {
            alert("HAPA Aşaması kaydedilirken bir sorun oluştu: " + response.message)
        }
        // window.location.reload()
        return;
    }

    const handleOptionClick1 = (optionId: string) => {

        if (question1 === optionId) {
            setQuestion1(null); // Seçiliyse geri al
            setIsValidQuestion1(false)
            setQuestion1Point(0)
            setQuestionGroupPuan(questionGroupPuan??0-getChoiceValue(parseInt(optionId)))
            
            setIsSelectedQ1C1(false)
            setIsSelectedQ1C5(false)

            if (selectedDay > 0 || selectedMonth > 0 || selectedYear > 0) {
                setSelectedDate(true)    
            } else {
                setSelectedDate(false)
            }

            if (selectedDay2 > 0 || selectedMonth2 > 0 || selectedYear2 > 0) {
                setSelectedDate2(true)    
            } else {
                setSelectedDate2(false)
            }

        } else {
            setQuestion1(optionId); // Değilse seç
            setIsValidQuestion1(true)
            setQuestion1Point(getChoiceValue(parseInt(optionId)))
            setQuestionGroupPuan(questionGroupPuan??0+getChoiceValue(parseInt(optionId)))
        
            if (parseInt(optionId) === 5) {
                setIsSelectedQ1C5(true)
                setIsSelectedQ1C1(false)

                setSelectedDate2(true)
                
                if (selectedDay > 0 || selectedMonth > 0 || selectedYear > 0) {
                    setSelectedDate(true)    
                } else {
                    setSelectedDate(false)
                }

            } else if (parseInt(optionId) === 2) {
                setIsSelectedQ1C1(true)
                setIsSelectedQ1C5(false)

                setSelectedDate(true)
                setSelectedDate2(true)

            } else {
                setIsSelectedQ1C1(false)
                setIsSelectedQ1C5(false)
                
                setSelectedDate(true)
                if (selectedDay2 > 0 || selectedMonth2 > 0 || selectedYear2 > 0) {
                    setSelectedDate2(true)    
                } else {
                    setSelectedDate2(false)
                }
            }
        }
    };

    const handleExcelResultClick = (appointmentId: number, type: number) => {
        // Butona tıklandığında yapılacak işlemler buraya yazılır
        console.log('Butona tıklandı!');

        if (!appointmentId) {
            alert("Randevu bilgileri getirilemediğinden excel alınamıyor.")
            return;
        }

        getAppointmentQuestionExcelResult(appointmentId, 15001, appointment.appointmentStartDate)//HAPA
    };

    const renderOptions = (input: number) => {
        const options: JSX.Element[] = [];
        
        for (let x = 0; x <= input; x++) {
            options.push(<option key={x} value={x}>{x === 0 ? '' : x}</option>);
        }
        return options;
    };

    const [selectedDay, setSelectedDay] = useState<number>(0);
    const [selectedMonth, setSelectedMonth] = useState<number>(0);
    const [selectedYear, setSelectedYear] = useState<number>(0);

    const [selectedDay2, setSelectedDay2] = useState<number>(0);
    const [selectedMonth2, setSelectedMonth2] = useState<number>(0);
    const [selectedYear2, setSelectedYear2] = useState<number>(0);

    const [selectedDate, setSelectedDate] = useState<boolean>(false);
    const [selectedDate2, setSelectedDate2] = useState<boolean>(false);

    const handleDayChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedDay(parseInt(event.target.value));

        if (selectedMonth > 0 || selectedYear > 0) {
            setSelectedDate(true)
        } else {
            if (isSelectedQ1C1) {
                setSelectedDate(true)
            } else if (isSelectedQ1C5 && parseInt(event.target.value) <= 0) {
                setSelectedDate(false)
            } else {
                setSelectedDate(true)
            }
        }
    };

    const handleDayChange2 = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedDay2(parseInt(event.target.value));

        if (selectedMonth2 > 0 || selectedYear2 > 0) {
            setSelectedDate2(true)
        } else {
            if (!isSelectedQ1C5 && !isSelectedQ1C1 && parseInt(event.target.value) <= 0) {
                setSelectedDate2(false)
            } else {
                setSelectedDate2(true)
            }
        }
    };

    const handleMonthChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedMonth(parseInt(event.target.value));

        if (selectedDay > 0 || selectedYear > 0) {
            setSelectedDate(true)
        } else {
            if (isSelectedQ1C1) {
                setSelectedDate(true)
            } else if (isSelectedQ1C5 && parseInt(event.target.value) <= 0) {
                setSelectedDate(false)
            } else {
                setSelectedDate(true)
            }
        }
    };

    const handleMonthChange2 = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedMonth2(parseInt(event.target.value));

        if (selectedDay2 > 0 || selectedYear2 > 0) {
            setSelectedDate2(true)
        } else {
            if (!isSelectedQ1C5 && !isSelectedQ1C1 && parseInt(event.target.value) <= 0) {
                setSelectedDate2(false)
            } else {
                setSelectedDate2(true)
            }
        }
    };

    const handleYearChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedYear(parseInt(event.target.value));

        if (selectedDay > 0 || selectedMonth > 0) {
            setSelectedDate(true)
        } else {
            if (isSelectedQ1C1) {
                setSelectedDate(true)
            } else if (isSelectedQ1C5 && parseInt(event.target.value) <= 0) {
                setSelectedDate(false)
            } else {
                setSelectedDate(true)
            }
        }
    };

    const handleYearChange2 = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedYear2(parseInt(event.target.value));

        if (selectedMonth2 > 0 || selectedDay2 > 0) {
            setSelectedDate2(true)
        } else {
            if (!isSelectedQ1C5 && !isSelectedQ1C1 && parseInt(event.target.value) <= 0) {
                setSelectedDate2(false)
            } else {
                setSelectedDate2(true)
            }
        }
    };

    const [isChecked, setIsChecked] = useState<boolean>(false);

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);

        if (!isChecked) {
            setSelectedDate2(true)   
        } else {
            
            if (selectedDay2 > 0 || selectedMonth2 > 0 || selectedYear2 > 0) {
                setSelectedDate2(true)   
            } else {
                setSelectedDate2(false)
            }
        }
    };

    return (

        <Accordion activeKey={activeQuestionAccordion} onSelect={toggleQuestionAccordion}>
            <Card key={'2'}>
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <Button className='d-flex justify-content-between align-items-center w-100' variant='link' onClick={(e) => toggleQuestionAccordion('2', e)}>
                            <div className='text-left text-gray-700'>{"HAPA Aşaması"}</div>
                            <div className='text-center text-gray-700 fs-7'>{questionGroupPuanValid ? `AŞAMA: ${questionGroupPuan ?? 0}` : "TEST DOLDURULMADI"}</div>
                            <div className='text-right'></div>
                        </Button>
                        <div></div>
                        <button
                            type="button"
                            about='Excel'
                            title='CO Test Sonucunu İndir'
                            className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                            onClick={() => handleExcelResultClick(appointmentId ?? 0, 15001)}>
                            {/* 15001: HAPA Excel Type
                                15002: FNBT Excel Type 
                                15003: WEMİOÖ Excel Type
                        */}
                            <i className="ki-duotone ki-file-down fs-2"><span className="path1"></span><span className="path2"></span></i>
                        </button>
                    </div>
                </Card.Header>
                <Accordion.Collapse eventKey={'2'}>
                    <Card.Body>
                        <Form onSubmit={handleUpdate}>
                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Yakın zamanda sigara içtiniz mi?</Form.Label>
                                    <div className="d-grid gap-2">
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question1 === '2' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick1('2')}
                                        >
                                            Evet ve bırakmayı düşünmüyorum.
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question1 === '3' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick1('3')}
                                        >
                                            Evet ama bırakmayı düşünüyorum.
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question1 === '4' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick1('4')}
                                        >
                                            Evet ama ciddi olarak bırakmayı düşünüyorum.
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question1 === '5' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick1('5')}
                                        >
                                            Hayır, sigarayı çoktan bıraktım.
                                        </Button>
                                        <Form.Control.Feedback type="invalid" style={{ display: isValidQuestion1 ? 'none' : 'block' }}>
                                            Lütfen seçim yapınız.
                                        </Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                            </Row>

                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Sigarayı çoktan bıraktıysanız, ne kadar süre önce sigarayı bıraktınız?</Form.Label>
                                    <div className="d-flex align-items-center">
                                        <Form.Group as={Col} className="me-2">
                                            <Form.Label>Gün</Form.Label>
                                            <Form.Select
                                                aria-label="Gün"
                                                onChange={handleDayChange}
                                                value={selectedDay??0}
                                                size="lg" // Select boyutunu büyük yapmak için
                                            >
                                                {renderOptions(30)}
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group as={Col} className="me-2">
                                        <Form.Label>Ay</Form.Label>
                                        <Form.Select
                                            aria-label="Ay"
                                            onChange={handleMonthChange}
                                            value={selectedMonth??0}
                                            size="lg" // Select boyutunu büyük yapmak için
                                        >
                                            {renderOptions(11)}
                                        </Form.Select>
                                        </Form.Group>
                                        <Form.Group as={Col} className="me-2">
                                        <Form.Label>Yıl</Form.Label>
                                        <Form.Select
                                            aria-label="Yıl"
                                            onChange={handleYearChange}
                                            value={selectedYear??0}
                                            size="lg" // Select boyutunu büyük yapmak için
                                        >
                                            {renderOptions(99)}
                                        </Form.Select>
                                        </Form.Group>
                                        <Form.Group as={Col} className="ms-2">
                                            <Form.Label className='mt-10'>...önce sigarayı bıraktım</Form.Label>
                                        </Form.Group>
                                    </div>
                                </Form.Group>
                                <Form.Control.Feedback type="invalid" style={{ display: selectedDate ? 'none' : 'block' }}>
                                    Lütfen süre seçiniz.
                                </Form.Control.Feedback>
                            </Row>

                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Sigarayı bırakmayı düşünüyorsanız, ne kadar süre içinde sigarayı bırakmayı düşünüyorsunuz?</Form.Label>
                                    <Form.Check
                                        className="me-5 mb-5 mt-5"
                                        type="checkbox"
                                        label="Bu konuda kararsızım."
                                        checked={isChecked}
                                        onChange={handleCheckboxChange}
                                    />
                                    <div className="d-flex align-items-center">
                                        <Form.Group as={Col} className="me-2">
                                            <Form.Label>Gün</Form.Label>
                                            <Form.Select
                                                aria-label="Gün"
                                                onChange={handleDayChange2}
                                                value={selectedDay2??0}
                                                size="lg" // Select boyutunu büyük yapmak için
                                            >
                                                {renderOptions(30)}
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group as={Col} className="me-2">
                                        <Form.Label>Ay</Form.Label>
                                        <Form.Select
                                            aria-label="Ay"
                                            onChange={handleMonthChange2}
                                            value={selectedMonth2??0}
                                            size="lg" // Select boyutunu büyük yapmak için
                                        >
                                            {renderOptions(11)}
                                        </Form.Select>
                                        </Form.Group>
                                        <Form.Group as={Col} className="me-2">
                                        <Form.Label>Yıl</Form.Label>
                                        <Form.Select
                                            aria-label="Yıl"
                                            onChange={handleYearChange2}
                                            value={selectedYear2??0}
                                            size="lg" // Select boyutunu büyük yapmak için
                                        >
                                            {renderOptions(99)}
                                        </Form.Select>
                                        </Form.Group>
                                        <Form.Group as={Col} className="ms-2">
                                            <Form.Label className='mt-10'>...içinde bırakmayı düşünüyorum.</Form.Label>
                                        </Form.Group>
                                    </div>
                                </Form.Group>
                                <Form.Control.Feedback type="invalid" style={{ display: selectedDate2 ? 'none' : 'block' }}>
                                    Lütfen süre seçiniz.
                                </Form.Control.Feedback>
                            </Row>

                            <Row className='mb-3 mt-10'>
                                <Form.Group as={Col}>
                                    <Button variant='primary' onClick={handleUpdate}>
                                        Kaydet
                                    </Button>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    )
}

export default PatientAppointmentCOQuestions
